<template>
	<FieldWrapper v-if="field" :title="field.name + (titleSuffix ? ' – ' + titleSuffix : '')" :def="field" :control="control" ref="wrap" class="Field FieldWrapper" :data-cy="'field-' + field.id" :tableCell="tableCell">
		<!-- TODO: do we need to support single line fields with "Text" type? -->
		<TextField v-if="field.type == 'Symbol' && (!control.widgetId || control.widgetId == 'singleLine')" 			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<LongTextField v-if="field.type == 'Symbol' && control.widgetId == 'multipleLine'"								:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<DropdownField v-if="field.type == 'Symbol' && control.widgetId == 'dropdown'"									:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<SlugField v-if="field.type == 'Symbol' && (control.widgetId == 'slugEditor' || control.widgetId == 'slug')"	:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			:entry="entry" :locale="locale" 
		/>
		<RadioField v-if="field.type == 'Symbol' && control.widgetId == 'radio'"										:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<UrlField v-if="field.type == 'Symbol' && control.widgetId == 'urlEditor'"										:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<QrGeneratorField v-if="field.type == 'Symbol' && control.widgetId == 'qrGenerator'"							:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<PeakAttributeField attribute="ProductType" v-if="field.type == 'Symbol' && control.widgetId == 'testcaseProductType'"			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<PeakAttributeField attribute="ProductCategory" v-if="field.type == 'Symbol' && control.widgetId == 'testcaseProductCategory'"	:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />

		<!-- TODO: this is a weird hack to check on the widgetId length - actually these 'id' widgets should be mapped to something at import -->
		<TagsField v-if="field.type == 'Array' && field.items.type == 'Symbol' && (!control.widgetId || control.widgetId.length > 20 || control.widgetId == 'tagEditor')"
																														:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<CheckboxesField v-if="field.type == 'Array' && field.items.type == 'Symbol' && control.widgetId == 'checkbox'"	:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<!-- TODO: the listInput in CF is actually a comma separated text input -->
		<TagsField v-if="field.type == 'Array' && field.items.type == 'Symbol' && control.widgetId == 'listInput'"		:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />

		<NumberField v-if="field.type == 'Number' && (!control.widgetId || control.widgetId == 'numberEditor')"			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<NumberField v-if="field.type == 'Integer' && (!control.widgetId || control.widgetId == 'numberEditor')"		:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<RatingField v-if="field.type == 'Integer' && control.widgetId == 'rating'"										:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<DropdownField v-if="field.type == 'Integer' && control.widgetId == 'dropdown'"									:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<RadioField v-if="field.type == 'Integer' && control.widgetId == 'radio'"										:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />

		<BooleanField v-if="field.type == 'Boolean'"																	:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="value" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />

		<DateField v-if="field.type == 'Date'"																			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />

		<LongTextField v-if="field.type == 'Text' && (!control.widgetId || control.widgetId == 'multipleLine')"			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<TextField v-if="field.type == 'Text' && control.widgetId == 'singleLine'"										:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<!-- TODO: CF actually has an editor for markdown - do we need it? -->
		<LongTextField v-if="field.type == 'Text' && control.widgetId == 'markdown'"									:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<RichTextField v-if="field.type == 'RichText' && !multiplayerRteEnabled"										:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			:locale="locale"
			@change="$emit('change', $event)"
			@subedit="forwardSubedit"
			@subeditAsset="forwardSubeditAsset"
		/>
		<!-- new RTE. Connected to the entry's collab room when :multiplayer is true (then the collab worker persists it), otherwise a plain editor on `value` -->
		<RichTextEditorMultiplayer v-if="field.type == 'RichText' && multiplayerRteEnabled"								:title="field.name" :def="field" :control="control" :disabled="disabled" :value="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			:locale="locale"
			:entry="entry"
			:multiplayer="effectiveMultiplayer"
			@input="model = $event"
			@change="$emit('change', $event)"
			@subedit="forwardSubedit"
			@subeditAsset="forwardSubeditAsset"
		/>

		<LocationField v-if="field.type == 'Location'"																	:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			:entry="entry"
		/>

		<JsonField v-if="field.type == 'Object' && (!control.widgetId || control.widgetId == 'objectEditor')"			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell" />
		<JsonTableField v-if="field.type == 'Object' && control.widgetId == 'jsonTable'"								:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			@change="$emit('change', $event)"
		/>
		<JsonWgs84PolylineField v-if="field.type == 'Object' && control.widgetId == 'jsonWgs84Polyline'"				:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			@change="$emit('change', $event)"
		/>
		<JsonAutotestSettings v-if="field.type == 'Object' && control.widgetId == 'autotestSettings'"					:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			:entry="entry"
			@subedit="forwardSubedit"
			@change="$emit('change', $event)"
		/>

		<!-- TODO: better support for entryCardsEditor -->
		<!-- refList and refListSmall are legacy - probably only exist in a test space -->
		<ReferencesField v-if="(field.type == 'Array' && field.items?.linkType == 'Entry' || field.type == 'Link' && field.linkType == 'Entry') && (!control.widgetId || control.widgetId == 'entryLinkEditor' || control.widgetId == 'entryLinksEditor' || control.widgetId == 'entryCardsEditor' || control.widgetId == 'entryLinksEditorSmall' || control.widgetId == 'refList' || control.widgetId == 'refListSmall')"
																														:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			@subedit="forwardSubedit"
		/>

		<AssetsField v-if="field.type == 'Array' && field.items.linkType == 'Asset'"									:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			@subeditAsset="forwardSubeditAsset"
		/>
		<AssetsField v-if="field.type == 'Link' && field.linkType == 'Asset'"											:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			@subeditAsset="forwardSubeditAsset"
		/>

		<FileField v-if="field.type == 'File'"																			:title="field.name" :def="field" :control="control" :disabled="disabled" v-model="model" @wrapper="$refs.wrap.onWrapper($event)" :tableCell="tableCell"
			:entry="entry"
		/>

		<!-- TODO: BulkEditor -->
	</FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper.vue'
import TextField from './TextField.vue'
import RichTextField from './RichTextField.vue'
import ReferencesField from './ReferencesField.vue'
import CheckboxesField from './CheckboxesField.vue'
import TagsField from './TagsField.vue'
import BooleanField from './BooleanField.vue'
import DropdownField from './DropdownField.vue'
import SlugField from './SlugField.vue'
import UrlField from './UrlField.vue'
import LongTextField from './LongTextField.vue'
import NumberField from './NumberField.vue'
import RatingField from './RatingField.vue'
import RadioField from './RadioField.vue'
import DateField from './DateField.vue'
import LocationField from './LocationField.vue'
import JsonField from './JsonField.vue'
import AssetsField from './AssetsField.vue'
import FileField from './FileField.vue'
import QrGeneratorField from './QrGeneratorField.vue'
import PeakAttributeField from './PeakAttributeField.vue'
import JsonTableField from './JsonTableField.vue'
import JsonWgs84PolylineField from './JsonWgs84PolylineField.vue'
import JsonAutotestSettings from './JsonAutotestSettings.vue'

export default {
	name: 'Field',
	components: {
		// Loaded on demand: with the multiplayer flag off, none of slate / yjs /
		// @slate-yjs is fetched or evaluated, and it stays out of the main bundle.
		RichTextEditorMultiplayer: () => import('./RichTextEditorMultiplayer.vue'),
		TextField, FieldWrapper, RichTextField, ReferencesField, CheckboxesField, TagsField, BooleanField, DropdownField, SlugField, UrlField, LongTextField, NumberField, RatingField, RadioField, DateField, LocationField, JsonField, AssetsField, FileField, QrGeneratorField, JsonTableField, JsonWgs84PolylineField, JsonAutotestSettings, PeakAttributeField },
	inject: [ 'locales', 'settings' ],
	provide() {
		return {
			localeObject: this.localeObject,
		}
	},
	props: {
		control: Object,
		entry: Object,
		field: Object,
		value: [ String, Number, Object, Array, Boolean ],
		titleSuffix: String,
		locale: String,
		localeObject: Object,
		disabled: Boolean,
		tableCell: Boolean,
		// ATT: the explicit default is what stops Vue from casting an absent Boolean
		//      prop to false, which is what keeps this tri-state.
		multiplayer: { type: Boolean, default: null },
	},
	data: () => ({
		model: null,
	}),
	computed: {
		// Which RichText implementation to use - the rollout flag, and nothing else.
		// Deliberately independent of the collab host: the new editor also runs
		// without a room.
		multiplayerRteEnabled() {
			return !!this.settings?.multiplayerRte
		},
		// ...and whether that editor connects to a room. Without an explicit prop:
		// only when there is something to connect to and a saved entry to have a
		// room for. That way places that render fields outside of the entry editor
		// (the type editor's default value, compare views, an unsaved entry) get a
		// plain editor without having to know about collaboration at all.
		effectiveMultiplayer() {
			return this.multiplayer ?? (
				this.multiplayerRteEnabled
				&& !!this.settings?.collabHost
				&& this.settings?.multiplayerRteConnect !== false
				&& !!this.entry?.sys?.id
			)
		},
	},
	watch: {
		value(n) {
			this.model = n
		},
		model(n) {
			this.$emit('input', n)
		},
	},
	methods: {
		forwardSubedit(link, callback) {
			this.$emit('subedit', link, callback)
		},
		forwardSubeditAsset(link, callback) {
			this.$emit('subeditAsset', link, callback)
		},
		getErrors() {
			return this.$refs.wrap?.errors ?? []
		},
		getWarnings() {
			return this.$refs.wrap?.warnings ?? []
		},
	},
	mounted() {
		this.model = this.value
	},
}
</script>

<style scoped>
</style>
